import React, { useEffect, useMemo, useState } from "react";
import Response from "../ResponseSection/Response";
import {
  TextField,
  Button,
  Divider,
  MenuItem,
  FormControl,
  Select,
  Box,
  Tabs,
  Tab,
  Paper,  
} from "@mui/material";
import { TabPanel, TabList, TabContext } from '@mui/lab'
import { useSelector } from "react-redux";
import { getApiObject } from "/src/utils/api_list";
import axios from "axios";
import CodeEditor from '@uiw/react-textarea-code-editor';
import Upload from "../Upload/Upload";
const Fields = ({param,urlChange}) =>{
  const [value,setValue] = useState('');  
  useEffect(() => {
    if (param && param.sample !== value) {
      setValue(param.sample);
    }
  }, [param]);

  return <div className="column">
        <div>
          <TextField
            spellCheck={false}
            value={value}
            required={!param.isOptional}
            variant="outlined"
            size={"small"}
            label={param.val}
            onChange={(e) => {
              setValue(e.target.value);
              urlChange(param.val,e.target.value);
            }}
          />
        </div>
  </div>
}

const onlyEncodedParamsAllowed = {
  number_formatter : ["pattern"]
}


function RequestForm() {
  const { baseUrl,user, token} = useSelector((state) => state.queryParams);
  const { activeApi } = useSelector((state) => state.apiHelpSlice);
  const [reqUrl, setReqUrl] = useState("");
  const [method, setMethod] = useState("get");
  const [apiResponse, setApiResponse] = useState("");
  const [tabValue,setTabValue] = useState(0);
  const [files,setFiles] = useState([]);
  const [isUploadSupport,setIsUploadSupport] = useState(false);
  const [isPostAPI,setIsPostAPI] = useState(false);
  const [jsonData, setJsonData] = useState('');
  const [action, setAction] = useState('');
  useEffect(() => {
    if (baseUrl) {
      let obj = getApiObject(activeApi);
      // let url = `${baseUrl}/workbench?action=${activeApi}${obj?.params?.filter(e=>e?.val === 'user')?.length ? '' : '&user=${user}'}`;
      let url = `${baseUrl}/workbench?action=${activeApi}&user=${user}`;
      if (activeApi === 'record_data_portioning_relative' || activeApi === 'record_data_portioning_exact') {
        url = `${baseUrl}/workbench?action=record_data_portioning&user=${user}`;
      }

      if (obj?.isUpload) setIsUploadSupport(true);
      else setIsUploadSupport(false);
      if(obj?.method?.toLocaleLowerCase() === "post") {
        setSamplePostData(obj?.body || []);
        setMethod('post');
        setAction(obj);
        setIsPostAPI(true);
      }else {
        setIsPostAPI(false);
        setJsonData('')
        setMethod('get');
      }
      let newUrl = url;
      obj?.params?.forEach((o) => {
        newUrl += `&${o.val}=${o.sample}`;
      });
      setReqUrl(newUrl);
    }
    setApiResponse("");
    setFiles([]);
  }, [baseUrl, activeApi]);
  
  useEffect(() => {
    if (method === "post") {
      if (action?.isUpload) {
        setIsUploadSupport(true)
      } else {
        setIsUploadSupport(false)
      }
      setIsPostAPI(true);
    } else {
      setIsPostAPI(false);
      setIsUploadSupport(false)
    }
  }, [method]);

  const setSamplePostData = (bodyObj) =>{
    const sampleBody = {};
    bodyObj.forEach((o) => {
      sampleBody[o.val] = o?.sample || '';
    });
    setJsonData(JSON.stringify(sampleBody,null,2));
  }

  const fileUploadHandler = (requestData) =>{
    // Appending Files
    const formdata = new FormData();
    files.forEach((e,i)=>{
      formdata.append(`file${i}`,e);
    })
    Object?.keys(requestData)?.forEach((e,i)=>{
      formdata.append(e,requestData[e]);
    })
    return formdata;
  }

  const getRequestedUrl = (url) => {
    let apiObj = getApiObject(activeApi);
    if(onlyEncodedParamsAllowed[apiObj.val]) {
      const encodedParams = onlyEncodedParamsAllowed[apiObj.val];
      const params = new URLSearchParams(url);
      encodedParams.forEach(e => {
        if (params.has(e)) {
          console.log(e,params.get(e));
          params.set(e, encodeURIComponent(params.get(e)));
        }
      })
      let newURL = ""
      for (let key of params.keys()) {
        newURL += `${key}=${params.get(key)}&`
      }
      return newURL;
    }
    return url;
  }

  const handleRequest = (method) => {
    const requestedUrl = getRequestedUrl(reqUrl);
    if (requestedUrl && method) {
      if (method === "post") {
        let requestData = {};
        const bodyObj = jsonData ? JSON.parse(jsonData) : {};
        let apiObj = getApiObject(activeApi);
        apiObj?.body?.forEach((o) => {
          requestData[o.val] = o.type === "number" ? Number(bodyObj?.[o.val] || '') : (bodyObj?.[o.val] || '');
        });

        if (isUploadSupport) requestData = fileUploadHandler(requestData)
        axios
          .post(requestedUrl, requestData, {
            headers: isUploadSupport ? {
              'Content-Type': 'multipart/form-data',
              "Authorization": `Bearer ${token}`,
            } : {},
          })
          .then((response) => {
            setApiResponse(response.data || response?.data?.message);
          })
          .catch((err) => {
            setApiResponse(err.message);
          });
      } else if (method === "get") {
        axios
          .get(requestedUrl , {
            headers: {
              "Authorization": `Bearer ${token}`
            }
          })
          .then((response) => {
            setApiResponse(response.data || response?.data?.message);
          })
          .catch((err) => {
            setApiResponse(err.message);
          });
      }
    }
  };

  const handleReqParamsTextFieldChange = (name, value) => {
    let apiObj = getApiObject(activeApi);
    const updatedApiObj = { ...apiObj };
    let newUrl = `${baseUrl}/workbench?action=${apiObj.val}&user=${user}`;
    
    updatedApiObj.params.forEach((o) => {
      if(o.val === name){
        newUrl += `&${name}=${value}`;
        o.sample = value;
      }
      else newUrl += `&${o.val}=${o.sample}`;
    });
    setReqUrl(newUrl);
  };

  const generateTextFields = useMemo(() => {
    const obj = getApiObject(activeApi);
    if (!activeApi || !obj.params) return null;

    return obj.params.map((param, index) => (
        <Fields param={param} urlChange={handleReqParamsTextFieldChange} />
    ));
  },[activeApi, reqUrl]);
  const handleMethodChange = (e) => {
    const value = e.target.value;
    setMethod(value);
  };

  return (
    <Box className="body">
      <div>
        <div style={{ height: "7vh" }}>
          <div style={{ display: "flex", gap: 4 }}>
            <FormControl>
              <Select
                id="method"
                value={method}
                size="small"
                onChange={(e) => handleMethodChange(e)}>
                <MenuItem value={"get"}>Get</MenuItem>
                <MenuItem value={"post"}>Post</MenuItem>
              </Select>
            </FormControl>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <div style={{ flex: 1 }}>
              <TextField fullWidth size="small" value={reqUrl}></TextField>
            </div>
            <div>
              <Button
                size='small'
                variant="contained"
                style={{ backgroundColor: "grey" }}
                onClick={() => {
                  handleRequest(method);
                }}>
                Send
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="request-body"
        style={{
          display: "flex",
          position: "relative",
          height: "35vh !important",
        }}>
        <Paper sx={{ height: "100%" }}>
          <TabContext value={tabValue}>
            <TabList
              onChange={(e, value) => setTabValue(value)}
              textColor="grey"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "grey",
                  color:'grey'
                },
              }}>
              <Tab value={0} label="Query Param"></Tab>
              {isPostAPI && <Tab value={1} label="Body"></Tab>}
              {isUploadSupport && <Tab value={2} label="Upload File"></Tab>}
            </TabList>
            <TabPanel
              value={0}
              className="scrollBar"
              sx={{
                backgroundColor: "",
                height: "30vh",
                overflowY: "auto",
                borderRadius: "3px",
                padding: "15px",
                border: "1px solid #EDEDED",
              }}>
              <div className="row">{activeApi && generateTextFields}</div>
            </TabPanel>
            <TabPanel
              value={1}
              className="scrollBar"
              sx={{
                backgroundColor: "",
                height: "30vh",
                overflowY: "auto",
                borderRadius: "3px",
                padding: "15px",
                border: "1px solid #EDEDED",
              }}>
              <CodeEditor
                value={jsonData}
                language="json"
                autoFocus={true}
                placeholder="Enter post body data."
                onChange={(evn) => setJsonData(evn.target.value)}
                padding={15}
                style={{
                  fontSize: 16,
                  backgroundColor: "inherit",
                  color: "grey",
                  fontFamily:
                    "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                }}
              />
            </TabPanel>
            <TabPanel
              value={2}
              className="scrollBar"
              sx={{
                backgroundColor: "",
                height: "30vh",
                overflowY: "auto",
                borderRadius: "3px",
                padding: "15px",
                border: "1px solid #EDEDED",
              }}>
              <Upload files={files} setFiles={setFiles} />
            </TabPanel>
          </TabContext>
        </Paper>
      </div>
      <Divider sx={{ margin: "0.5rem 0" }}></Divider>
      <div
        style={{
          backgroundColor: "#f2f2f2",
          borderRadius: "3px",
          height: "35vh",
        }}>
        <div
          className="response"
          style={{ overflowY: "auto", height: "100%", paddingLeft: "20px" }}>
          <Response response={apiResponse}></Response>
        </div>
      </div>
    </Box>
  );
}

export default RequestForm;
